import { Component, DestroyRef, Inject, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface CouponData {
  id: any;
}


export interface CouponElement {
  srNo: string;
  id: any;
  code: string;
  amount: string;
  coupon_type: string;
  allowed_count: string;
  total_count: string;
  action: any;
}

@Component({
  selector: 'app-coupon-code',
  templateUrl: './coupon-code.component.html',
  styleUrls: ['./coupon-code.component.scss'],
  standalone: false
})
export class CouponCodeComponent {
  displayedColumns: string[] = [
    'srNo',
    'code',
    'amount',
    'coupon_type',
    'allowed_count',
    'total_count',
    'action',
  ];

  ELEMENT_DATA: CouponElement[] = [];
  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<CouponElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  coupon_result: any;
  event_id: any | null;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }

  ngAfterViewInit() {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.Get_CouponCode();
    this.dataSource.paginator = this.paginator;
  }

  AddCoupon() {
    const dialogRef = this.dialog.open(add_coupon, {
      data: {
        // id: this.id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_CouponCode();
    });
  }

  EditCoupon(id: any) {
    const dialogRef = this.dialog.open(add_coupon, {
      data: {
        id: id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_CouponCode();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_CouponCode() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_coupon_code(this.event_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.coupon_result = data.data;
        for (const item of this.coupon_result) {
          this.ELEMENT_DATA = this.coupon_result.map((item: { code: any; amount: any; coupon_type: any; allowed_count: any; total_count: any; id: any; }, index: number) => ({
            srNo: index + 1,
            code: item.code,
            id: item.id,
            amount: item.amount,
            coupon_type: item.coupon_type,
            allowed_count: item.allowed_count,
            total_count: item.total_count,
            action: item.id
          })
          );
        }

        this.dataSource = new MatTableDataSource<CouponElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
  }



  DeleteCoupon(id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Coupon?');
    if (buttonClicked === true) {
      this.service.delete_coupon(id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.id !== id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Coupon Code Deleted Succesfully");
        });
    }
  }
}



@Component({
  selector: 'add_coupon',
  templateUrl: './add_coupon.html',
  styleUrls: ['./coupon-code.component.scss'],
  standalone: false
})
export class add_coupon {

  ScanningForm: FormGroup;
  id: any
  result: any;
  hide = true;
  code: any
  private destoryRef = inject(DestroyRef);
  coupon_data: any;
  coupon_type: any;
  amount: any;
  allowed_count: any;
  total_count: any;


  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_coupon>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: CouponData
  ) {
    this.id = data['id'];

    // Initialize total_count validators
    let totalCountValidators = [
      Validators.pattern(/^(\s*\S+\s*)+$/)
    ];

    // Add the required validator conditionally if id is present
    if (this.id) {
      totalCountValidators.push(Validators.required);
    }

    // Initialize form group
    this.ScanningForm = this.member.group({
      id: this.id,
      code: ['', [Validators.required, Validators.pattern(/^[A-Z0-9_-]+$/)]],
      coupon_type: ['', Validators.required],
      amount: [{ value: '', disabled: true }, Validators.required],
      allowed_count: [''],
      total_count: ['', totalCountValidators]
    });

  }

  ngOnInit(): void {

    // uppercase coupon code
    this.ScanningForm.get('code')?.valueChanges.subscribe(value => {
      if (value) {
        const upperValue = value.replace(/\s+/g, '').toUpperCase();
        if (value !== upperValue) {
          this.ScanningForm.get('code')?.setValue(upperValue, { emitEvent: false });
        }
      }
    });

    // coupon type change logic
    this.ScanningForm.get('coupon_type')?.valueChanges.subscribe(type => {
      const amountControl = this.ScanningForm.get('amount');

      amountControl?.reset();
      amountControl?.enable();

      if (type === 'percentage') {
        amountControl?.setValidators([
          Validators.required,
          Validators.min(1),
          Validators.max(100)
        ]);
      } else if (type === 'flat') {
        amountControl?.setValidators([
          Validators.required,
          Validators.min(1)
        ]);
      }

      amountControl?.updateValueAndValidity();
    });

    // ✅ THIS WAS MISSING
    if (this.id) {
      this.Get_Coupon_By_Id(this.id);
    }
  }


  get isPercentage(): boolean {
    return this.ScanningForm.get('coupon_type')?.value === 'percentage';
  }


  Get_Coupon_By_Id(id: any) {
    this.service.get_coupon_code_by_id(id).subscribe(
      (data: any) => {
        this.coupon_data = data.data;

        this.ScanningForm.patchValue({
          id: this.coupon_data[0].id,
          code: this.coupon_data[0].code,
          coupon_type: this.coupon_data[0].coupon_type,
          amount: this.coupon_data[0].amount,
          allowed_count: this.coupon_data[0].allowed_count,
          total_count: this.coupon_data[0].total_count
        });

        this.ScanningForm.get('amount')?.enable();
        this.ScanningForm.get('amount')?.updateValueAndValidity();
      });
  }

  onFormSubmit() {
    const payload = {
      ...this.ScanningForm.value,
      code: this.ScanningForm.value.code?.toUpperCase()
    };

    const hasNonEmptyField = Object.values(payload).some(value => value !== null && value !== '');
    if (this.ScanningForm.valid && hasNonEmptyField) {

      if (this.id) {
        this.service.edit_coupon_code(payload).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Coupon Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_coupon_code(payload).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Coupon Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}
